import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { TimesheetlistPage } from '../../pages/timesheetlist/timesheetlist';
import{ ThankYouPage } from '..//thank-you/thank-you';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PopoverController } from 'ionic-angular';
import { PopoverPage } from '../popover/popover';
import { RejectPage } from '../../pages/reject/reject';

/**
 * Generated class for the ConfirmType1MonthlyPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-confirm-type1-monthly',
  templateUrl: 'confirm-type1-monthly.html',
})
export class ConfirmType1MonthlyPage {

  dt1grid1: any;
  dt2grid1: any;
  // dt1grid2: Array<any>= [];
  dt1grid2: any;
  dt2grid2: any;
  dt1grid3: any;
  shownGroup = null;
  nrowsGrid1: number;
  nrowsGrid2: number;
  res_approve: any;

  expenses_table1: any;
  expenses_table2: any;
  nrowsExpenses: number;
  offset_expenses:number = 1000;

  offset_grid2:number = 10;
  // offset_expenses:number = 20;

  constructor(public global: GlobalProvider, public navCtrl: NavController, public navParams: NavParams,
  public http: HttpClient, public popoverCtrl: PopoverController
  , private alertCtrl: AlertController) {

    // debugger;
    if(this.global.grid1Visibility){

      //debugger;
      // this.dt1grid1 = JSON.parse(this.global.dt_grid1[0]);
      // this.dt2grid1 = JSON.parse(this.global.dt_grid1[1]);

      this.dt1grid1 = this.global.dt_grid1.Table;
      this.dt2grid1 = this.global.dt_grid1.Table1;

      //nRows represent the number of rows to be drawn in Grid1, whether there will be overtime,.. or not.
      this.nrowsGrid1 = this.dt2grid1.length;
      //console.log('nRowsGrid1: ' + this.nrowsGrid1);
      //console.log(this.dt1grid1[0]['COL'  + this.global.ndays]);
    }



    // if(this.global.grid2Visibility) {

    //   // for(var i=0; i < this.global.dt_grid2.length; i++){
    //   //   this.dt1grid2[i] = JSON.parse(this.global.dt_grid2[i]);
    //   // }

      
    //   this.dt1grid2 = JSON.parse(this.global.dt_grid2[0]);
    //   this.dt2grid2 = JSON.parse(this.global.dt_grid2[1]);


    //   //ADDED 10 ROWS AT THE BEGINNING TO SHIFT THE STARTING INDEX
    //   for(var i = 0; i < this.offset_grid2; i++) {
    //     this.dt1grid2.unshift([]);
    //     this.dt2grid2.unshift([]);
    //   }

    //   console.log(this.dt1grid2[0]);

    //   //nRows represent the number of rows to be drawn in Grid2, whether there will be overtime,.. or not.
    //   this.nrowsGrid2 = this.dt1grid2.length;
    //   console.log('nRowsGrid2: ' + this.nrowsGrid2);
    // }
    
    if (this.global.expensesVisibility){
      // debugger
      
      // for(var i = 0; i < this.offset_expenses; i++) {
      //   this.global.dt_expenses_total_confirm.unshift([]);
      //   // this.dt2grid2.unshift([]);
      // }
      this.nrowsExpenses = this.global.dt_expenses_total_confirm.length;
    }

    // if(this.global.grid3Visibility){
    //   this.dt1grid3 = JSON.parse(this.global.dt_grid3[0]);
    //   //nRows represent the number of rows to be drawn in Grid2, whether there will be overtime,.. or not.
    //   // this.nrowsGrid2 = this.dt2table3.length;
    //   // console.log('nRowsGrid2: ' + this.nrowsGrid2);
    //   }
  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage);
    popover.present({
      ev: myEvent
    });
  }
  
  toggleGroup(group) {
    if (this.isGroupShown(group)) {
        this.shownGroup = null;
    } else {
        this.shownGroup = group;
    }
  };

  isGroupShown(group) {
    return this.shownGroup === group;
  };


  //Custom Back to close the expandable
  back_button() {
    //this.global.shownGroup = null;
    //this.httpRequestTab2();
    //console.log(this.navCtrl.getViews()[0]);
  }

httpRequest_approve(){
  debugger
  //added to prevent consultants from chi approving timesheets
  if(this.global.AllowApproval === '0' && this.global.contacttype == '0'){
    let alert = this.alertCtrl.create({
      message: 'You are not authorised to approve this timesheet.',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            //back to timesheetlist
            this.navCtrl.push(TimesheetlistPage);

          }
        }
      ]
    });
    alert.present();
  } 
  else {
    this.global.createLoader();
    this.global.loading.present().then((result) => {


      var p:any={};
      p.timesheetid = this.global.timesheetid;
      p.contacttype = this.global.contacttype;
      p.zeroreason = '';

      if(this.global.contacttype == '1'){

        p.caption = 'SUBMIT TIMESHEET';

      }
      else if(this.global.contacttype == '0'){

        p.caption = 'Approve Now';

      }


      const params = new HttpParams()
      .set('j',JSON.stringify(p))


      this.http.post('timesheets/timesheet_approve/',params).subscribe(

        (data) => {
          //debugger;

            this.global.loading.dismiss();

              this.res_approve = data;
              if(this.res_approve.result==true){
                this.navCtrl.push(ThankYouPage);
              }
          },
          error => {
            alert(error);
          }
        );

      }).catch((err) => {

    });
  }

}

goToThankyou(){
  this.httpRequest_approve();
}

goToReject(){
  this.navCtrl.push(RejectPage);
}
backToTimesheets(){
  this.global.ndaysIndex = 1;
  this.navCtrl.push(TimesheetlistPage);
}

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ConfirmType1Page');
  }


}



// WEBPACK FOOTER //
// ./src/pages/confirm-type1-monthly/confirm-type1-monthly.ts